import {useLinePlotSettingsWithDefaults} from '../../WorkspaceDrawer/Settings/runLinePlots/utils/getLinePlotSettings';
import {type RunsLinePlotConfig} from '../types';

export const useRunsLinePlotSettings = (config: RunsLinePlotConfig) => {
  return useLinePlotSettingsWithDefaults(config);
};
